module.exports = __webpack_public_path__ + "static/media/service-img-05.63dd8de5.png";